import * as XLSX from "xlsx";
import { maintenance, MaintenanceArr } from "../../types/api";
import { sanitizeExportValue } from "../../common/utils";

const formatValue = (value: any): string => {
  if (value === null || value === undefined) return "N/A";
  if (Array.isArray(value)) return sanitizeExportValue(value.join(", "));
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (value instanceof Date) return value.toLocaleDateString();
  const formatted = String(value).trim() || "N/A";
  return sanitizeExportValue(formatted);
};
const createMaintenanceSheet = (
  allMaintenance: MaintenanceArr[]
): XLSX.WorkSheet => {
  const headers = [
    "check Internal/ external",
    "What is checked",
    "Last Date of Check",
    "Check completed by",
    "Observation",
    "Action taken",
    "Recheck Date",
    "Recheck By",
  ];

  const data = allMaintenance.map((item) => [
    formatValue(item.internalExternal),
    formatValue(item.Checked),
    formatValue(item.lastDateOfCheck),
    formatValue(item.checkCompletedBy),
    formatValue(item.observation),
    formatValue(item.actionTaken),
    formatValue(item.recheckDate),
    formatValue(item.recheckBy),
  ]);

  const ws = XLSX.utils.json_to_sheet([{}], { header: headers });
  XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: "A2" });
  return ws;
};

export const generateMaintenanceExcel = (
  maintenanceData: maintenance[]
): void => {
  const wb = XLSX.utils.book_new();

  const maintenanceArr = Array.isArray(maintenanceData)
    ? maintenanceData
    : [maintenanceData];
  const maintenanceSheet = createMaintenanceSheet(maintenanceArr);
  XLSX.utils.book_append_sheet(wb, maintenanceSheet, "Maintenance Details");
  const ws = wb.Sheets["Maintenance Details"];
  const colWidths = (headers: string[]): { wch: number }[] => {
    return headers.map((header, i) => {
      const dataWidth =
        ws["!data"]?.map((row: any[]) => String(row[i] || "").length) || [];
      return { wch: Math.max(header.length, ...dataWidth, 10) };
    });
  };
  ws["!cols"] = colWidths(Object.keys(ws).filter((k) => k.match(/^[A-Z]+1$/)));

  const maintenanceNumber = (maintenanceData as any)?.id || "maintenance";
  const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
  const filename = `Maintenance_${maintenanceNumber}_${timestamp}.xlsx`;

  // Write and download the file
  XLSX.writeFile(wb, filename);
};
